export default __webpack_public_path__ + "static/media/Gallery14.0692ffd4.jpg";